var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"nut-luckycard",style:({ height: _vm.height + 'px', width: _vm.width + 'px' })},[_c('div',{staticClass:"nut-content",style:({ backgroundColor: _vm.backgroundColor, fontSize: _vm.fontSize + 'px' }),domProps:{"innerHTML":_vm._s(_vm.content)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }